import FiltersProducts from "./FiltersProducts";

export default class SingleFilter extends HTMLDivElement {
    constructor() {
        super();
        this.filterName = this.dataset.filterName;
        this.filterType = this.dataset.filterType;
        this.inputs = this.querySelectorAll(`input[name^="${this.filterName}"]`);
    }

    connectedCallback() {
        this.watch();
    }

    /**
     * Écoute les événements du filtre.
     */
    watch() {
        this.inputs.forEach((input) => {
            input.addEventListener('change', this.filterChanged.bind(this));
        });
    }

    /**
     * Callback appelé lorsque la valeur du filtre est changée.
     *
     * @param event
     */
    filterChanged(event) {
        const filtersProducts = new FiltersProducts({
            name: this.filterName
        });
        filtersProducts.query();
    }

    /**
     * Retourne la ou les valeurs sélectionnées pour le filtre.
     *
     * @returns {{}|*|null|*[]} La forme du retour varie selon le type de filtre
     */
    getFilterValue() {
        if (this.filterType === 'range') {
            const value = {};
            this.inputs.forEach((input) => {
                if ( ! input.value || input.value === '') {
                    return;
                }

                if (input.name === `${this.filterName}[min]`) {
                    value.min = input.value;
                    return;
                }

                if (input.name === `${this.filterName}[max]`) {
                    value.max = input.value;
                }
            });

            return Object.keys(value).length > 0 ? value : null;
        }

        if (this.filterType === 'checkbox') {
            const value = [];
            this.inputs.forEach((input) => {
                if (input.checked) {
                    value.push(input.value);
                }
            });

            return value.length > 0 ? value : null;
        }

        if (this.filterType === 'radio') {
            for (const input of this.inputs) {
                if (input.checked) {
                    return input.value;
                }
            }
        }

        return null;
    }
}
